// This file and all other files in the TimePicker folder were copied and modified
// from the react-multi-date-picker source at commit a6184d121fe00532511950fda551773818622a69
import React, { useMemo } from "react"

import Arrow from "./Arrow"
import Select from "./Select"
import getValidProps from "./getValidProps"
import "./styles.css"

export default function TimePicker({
  state,
  setState,
  handleChange,
  position,
  calendarProps: { formattingIgnoreList },
  nodes,
  Calendar,
  hideSeconds,
  className = "",
  style = {},
  handleFocusedDate,
  minuteStep = 1,
  format = "YYYY/MM/DD",
  ...props
}) {
  let { date, selectedDate, multiple, range, focused } = state,
    meridiems = date.meridiems,
    availableDate = (multiple || range ? focused : selectedDate) || date,
    horizontal = ["left", "right"].includes(position)

  const mustDisplayMeridiem = useMemo(() => {
    let format = date._format

    if (typeof format !== "string") return false

    if (Array.isArray(formattingIgnoreList)) {
      formattingIgnoreList.forEach(item => {
        if (typeof item === "string") {
          format = format.replace(new RegExp(item, "g"), "")
        }
      })
    }

    return format.toLowerCase().includes("a") || format.includes("hh")
  }, [date._format, formattingIgnoreList])

  let isAm = mustDisplayMeridiem && availableDate.hour < 12

  return (
    <div style={{ display: "grid" }}>
      {horizontal && (
        <>
          <div style={{ margin: "auto" }}>
            <div style={{ fontSize: "16px" }}>{availableDate.month.name}</div>
            <div style={{ fontSize: "24px" }}>{availableDate.format("D")}</div>
            <div style={{ fontSize: "18px" }}>
              {availableDate.format("dddd")}
            </div>
          </div>
          <Select
            selectedDate={selectedDate}
            focused={focused}
            handleFocusedDate={handleFocusedDate}
            state={state}
            setState={setState}
            format={format}
          />
        </>
      )}
      <div
        className={`rmdp-time-picker ${position} ${className || ""}`}
        style={{
          direction: "ltr",
          minWidth: horizontal ? "120px" : "220px",
          ...style,
        }}
        {...getValidProps(props)}
      >
        {[
          ["hour", mustDisplayMeridiem ? "hh" : "HH"],
          ["minute", "mm"],
          ["second", "ss"],
        ].map(([name, token], index) => {
          if (name === "second" && hideSeconds) return null

          return (
            <Button
              key={index}
              name={name}
              values={getValues(name, token)}
              update={update}
              digits={date.digits}
              hideDivider={
                name === "second" || (name === "minute" && hideSeconds)
              }
              step={name === "minute" ? minuteStep : 1}
            />
          )
        })}
        <div
          style={{
            display: mustDisplayMeridiem ? "flex" : "none",
          }}
        >
          <Arrow direction="rmdp-up" onClick={toggleMeridiem} />
          <div className="rmdp-am">
            {(isAm ? meridiems[0][1] : meridiems[1][1]).toUpperCase()}
          </div>
          <Arrow direction="rmdp-down" onClick={toggleMeridiem} />
        </div>
      </div>
    </div>
  )

  function update(key, value) {
    availableDate[key] = value

    setDate()
  }

  function toggleMeridiem() {
    availableDate.hour += availableDate.hour < 12 ? 12 : -12

    setDate()
  }

  function setDate() {
    handleChange(selectedDate, {
      ...state,
      selectedDate,
      focused,
    })
  }

  function getValues(key, token) {
    if (!availableDate[key]) availableDate[key] = 0

    return [availableDate[key], availableDate.format(token)]
  }
}

function Button({
  name,
  values: [number, localeValue],
  update,
  digits,
  hideDivider,
  step = 1,
}) {
  return (
    <>
      <div>
        <Arrow
          direction="rmdp-up"
          onClick={() => update(name, number + step)}
        />
        <div className="rmdp-am">{localeValue}</div>
        <Arrow
          direction="rmdp-down"
          onClick={() => update(name, number - step)}
        />
      </div>
      {!hideDivider && <span className="dvdr">:</span>}
    </>
  )
}
